"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferHintsModal = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _OfferHint = require("../OfferHint");
var _jsxRuntime = require("react/jsx-runtime");
// built in bottom padding in dialog do not work for this scenario
const StyledDialog = (0, _mui.styled)(_components.Dialog)((param)=>{
    let { theme } = param;
    return {
        ["& .".concat(_components.dialogClasses.root)]: {
            paddingBottom: 0
        }
    };
});
// dialogRef is used in concept offer for size and whatever
const OfferHintsModal = (param)=>{
    let { isOpen, offers, onClose } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const dialogRef = /*#__PURE__*/ (0, _react.createRef)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const header = formatMessage('yourOffers');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDialog, {
        closeAfterTransition: true,
        fullWidth: true,
        maxWidth: "620px",
        size: "small",
        "data-testid": getTestId('offer-hints-modal'),
        "aria-label": header,
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: dialogRef,
            "data-testid": getTestId('offer-hints-modal-content'),
            children: offers.map((offer)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferHint.OfferHint, {
                    dialogRef: dialogRef,
                    offer: offer
                }, offer.offerId))
        })
    });
};
exports.OfferHintsModal = OfferHintsModal;
